


// import { useState } from "react";

// function PrivacyPolicy({ onClose }) {
//   const [checked, setChecked] = useState(false);

//   const handleSubmit = () => {
//     if (!checked) {
//       alert("Please accept Privacy Policy");
//       return;
//     }
//     alert("Privacy Policy accepted");
//     onClose();
//   };

//   return (
//     <div className="policy-overlay">
//       <div className="policy-box">
//         <h4>Shopeindia – Privacy Policy</h4>

//         <div className="policy-content">
//           <h6>1. Introduction</h6>
//           <p>
//             Shopeindia values your privacy and is committed to protecting
//             your personal information. This policy explains how we collect,
//             use, and safeguard your data.
//           </p>

//           <h6>2. Information We Collect</h6>
//           <ul>
//             <li>Name, phone number, email address</li>
//             <li>Shipping and billing address</li>
//             <li>Order and payment related information</li>
//             <li>Technical data such as IP address and browser type</li>
//           </ul>

//           <h6>3. How We Use Your Information</h6>
//           <ul>
//             <li>Process orders and deliveries</li>
//             <li>Provide customer support</li>
//             <li>Improve website performance</li>
//             <li>Send order-related updates</li>
//           </ul>

//           <h6>4. Data Sharing</h6>
//           <p>We do not sell or rent your personal information.</p>
//           <ul>
//             <li>Logistics and courier partners</li>
//             <li>Payment gateway providers</li>
//             <li>Legal authorities when required</li>
//           </ul>

//           <h6>5. Data Security</h6>
//           <p>
//             We use reasonable security measures to protect your data,
//             but no system is completely secure.
//           </p>

//           <h6>6. Cookies</h6>
//           <p>
//             Cookies may be used to enhance user experience and website analytics.
//           </p>

//           <h6>7. Third-Party Links</h6>
//           <p>
//             Our website may contain links to third-party websites such as
//             <b> hijama.cyberathon.com</b>. We are not responsible for their
//             privacy practices.
//           </p>

//           <h6>8. Your Rights</h6>
//           <ul>
//             <li>Access your personal information</li>
//             <li>Request correction or deletion</li>
//             <li>Withdraw consent</li>
//           </ul>

//           <h6>9. Policy Updates</h6>
//           <p>
//             This Privacy Policy may be updated from time to time.
//             Changes will be posted on this page.
//           </p>

//           <h6>10. Contact Us</h6>
//           <p>
//             <b>Address:</b> Shopeindia, Warud, Maharashtra, India<br />
//             <b>Phone:</b> 7820953826 / 7385743121<br />
//             <b>Email:</b>support@shopeindia.co.in<br />
//             <b>Website:</b> www.shopeindia.co.in
//           </p>
//         </div>

//         <div className="policy-check">
//           <input
//             type="checkbox"
//             id="privacy"
//             checked={checked}
//             onChange={(e) => setChecked(e.target.checked)}
//           />
//           <label htmlFor="privacy">I agree to the Privacy Policy</label>
//         </div>

//         <div className="policy-actions">
//           <button onClick={handleSubmit}>Submit</button>
//           <button className="cancel" onClick={onClose}>Close</button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default PrivacyPolicy;


import { useState } from "react";
import { createPortal } from "react-dom";

function PrivacyPolicy({ onClose }) {
  const [checked, setChecked] = useState(false);

  const handleSubmit = () => {
    if (!checked) {
      alert("Please accept the Privacy Policy to proceed.");
      return;
    }
    onClose();
  };

  return createPortal(
    <div style={overlayStyle}>
      <div style={boxStyle}>

        {/* Header */}
        <div style={headerStyle}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span style={{ fontSize: "28px" }}>🔒</span>
            <div>
              <h4 style={{ margin: 0, fontSize: "20px", fontWeight: "700", color: "#111" }}>
                Privacy Policy
              </h4>
              <p style={{ margin: 0, fontSize: "12px", color: "#777" }}>
                Shopeindia — Last Updated: January 1, 2026
              </p>
            </div>
          </div>
          <button onClick={onClose} style={closeBtnStyle}>✕</button>
        </div>

        {/* Scrollable Content */}
        <div style={contentStyle}>

          <p style={paraStyle}>
            At <b>Shopeindia</b> (<b>www.shopeindia.co.in</b>), we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains what data we collect, how we use it, and how we protect it when you use our website and services.
          </p>

          <Section title="1. Information We Collect">
            <p style={paraStyle}>We collect the following types of information when you use our platform:</p>
            <p style={{ ...paraStyle, fontWeight: "600" }}>a) Personal Information:</p>
            <ul style={listStyle}>
              <li>Full name, email address, and phone number</li>
              <li>Shipping and billing address</li>
              <li>Account credentials (username/password — stored securely)</li>
            </ul>
            <p style={{ ...paraStyle, fontWeight: "600" }}>b) Order & Transaction Information:</p>
            <ul style={listStyle}>
              <li>Products purchased, order history, and invoice details</li>
              <li>Payment method (we do NOT store card numbers or bank details)</li>
            </ul>
            <p style={{ ...paraStyle, fontWeight: "600" }}>c) Technical Data:</p>
            <ul style={listStyle}>
              <li>IP address, browser type, device information</li>
              <li>Pages visited, time spent, and click behavior (via cookies/analytics)</li>
            </ul>
          </Section>

          <Section title="2. How We Use Your Information">
            <ul style={listStyle}>
              <li>To process and fulfill your orders</li>
              <li>To communicate order status, shipping updates, and invoices</li>
              <li>To provide customer support and respond to queries</li>
              <li>To improve our website, products, and services</li>
              <li>To send promotional offers and newsletters (only if you opt-in)</li>
              <li>To comply with legal obligations</li>
            </ul>
          </Section>

          <Section title="3. Payment Data & Security">
            <p style={paraStyle}>
              All payment transactions are processed through <b>secure, PCI-DSS compliant payment gateways</b>. Shopeindia does <b>not</b> store, access, or retain your credit/debit card numbers, UPI IDs, or net banking credentials. Payment data is handled entirely by our trusted payment partners.
            </p>
          </Section>

          <Section title="4. Data Sharing">
            <p style={paraStyle}>We do <b>not sell, rent, or trade</b> your personal information to third parties. We may share your data only with:</p>
            <ul style={listStyle}>
              <li><b>Logistics & Courier Partners</b> — to deliver your orders (name, address, phone)</li>
              <li><b>Payment Gateway Providers</b> — to process transactions securely</li>
              <li><b>Legal Authorities</b> — when required by law or court order</li>
              <li><b>Analytics Tools</b> — anonymized data only (e.g., Google Analytics)</li>
            </ul>
          </Section>

          <Section title="5. Cookies">
            <p style={paraStyle}>
              Our website uses cookies to enhance user experience, maintain sessions, and analyze traffic. You can disable cookies through your browser settings, but this may affect website functionality. Types of cookies we use:
            </p>
            <ul style={listStyle}>
              <li><b>Session Cookies</b> — to keep you logged in during your visit</li>
              <li><b>Preference Cookies</b> — to remember your settings</li>
              <li><b>Analytics Cookies</b> — to understand how users interact with our site</li>
            </ul>
          </Section>

          <Section title="6. Data Retention">
            <p style={paraStyle}>
              We retain your personal information for as long as your account is active or as needed to fulfill the purposes outlined in this policy. You may request deletion of your account and data by contacting us at <b>support@shopeindia.co.in</b>.
            </p>
          </Section>

          <Section title="7. Your Rights">
            <p style={paraStyle}>You have the right to:</p>
            <ul style={listStyle}>
              <li>Access and review the personal data we hold about you</li>
              <li>Request correction of inaccurate data</li>
              <li>Request deletion of your personal data</li>
              <li>Withdraw consent for marketing communications at any time</li>
              <li>Lodge a complaint with a data protection authority</li>
            </ul>
            <p style={paraStyle}>To exercise any of these rights, contact us at <b>support@shopeindia.co.in</b>.</p>
          </Section>

          <Section title="8. Third-Party Links">
            <p style={paraStyle}>
              Our website may contain links to third-party websites. We are not responsible for the privacy practices of external sites. We encourage you to review the privacy policies of any third-party sites you visit.
            </p>
          </Section>

          <Section title="9. Children's Privacy">
            <p style={paraStyle}>
              Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from minors. If you believe a minor has provided us with personal data, please contact us immediately.
            </p>
          </Section>

          <Section title="10. Updates to This Policy">
            <p style={paraStyle}>
              We may update this Privacy Policy from time to time. Any changes will be posted on this page with the updated effective date. Continued use of our website after changes constitutes acceptance of the revised policy.
            </p>
          </Section>

          <Section title="11. Contact Us">
            <p style={paraStyle}><b>Shopeindia</b></p>
            <p style={paraStyle}><b>Address:</b> Shopeindia, Warud, Maharashtra, India</p>
            <p style={paraStyle}><b>Phone:</b>+91 7385743121</p>
            <p style={paraStyle}><b>Email:</b> support@shopeindia.co.in</p>
            <p style={paraStyle}><b>Website:</b> www.shopeindia.co.in</p>
          </Section>

        </div>

        {/* Checkbox */}
        <div style={checkboxRowStyle}>
          <input
            type="checkbox"
            id="privacy-check"
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            style={{ width: "16px", height: "16px", cursor: "pointer", accentColor: "#24aeb1" }}
          />
          <label htmlFor="privacy-check" style={{ fontSize: "14px", cursor: "pointer", color: "#333" }}>
            I have read and agree to the <b>Privacy Policy</b> of Shopeindia.
          </label>
        </div>

        {/* Actions */}
        <div style={actionsStyle}>
          <button onClick={handleSubmit} style={acceptBtnStyle}>
            ✓ Accept & Continue
          </button>
          <button onClick={onClose} style={cancelBtnStyle}>
            Close
          </button>
        </div>

      </div>
    </div>,
    document.body
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: "18px" }}>
      <h5 style={{ fontSize: "14px", fontWeight: "700", color: "#24aeb1", marginBottom: "8px", borderBottom: "1px solid #e8f8f8", paddingBottom: "4px" }}>
        {title}
      </h5>
      {children}
    </div>
  );
}

const overlayStyle = {
  position: "fixed", inset: 0,
  background: "rgba(0,0,0,0.65)",
  display: "flex", justifyContent: "center", alignItems: "center",
  zIndex: 99999, padding: "16px"
};
const boxStyle = {
  background: "#fff", width: "100%", maxWidth: "720px",
  borderRadius: "16px", display: "flex", flexDirection: "column",
  maxHeight: "90vh", boxShadow: "0 20px 60px rgba(0,0,0,0.3)", overflow: "hidden"
};
const headerStyle = {
  display: "flex", justifyContent: "space-between", alignItems: "center",
  padding: "18px 24px", borderBottom: "2px solid #e8f8f8",
  background: "#f7fffe", flexShrink: 0
};
const closeBtnStyle = {
  background: "#f1f5f9", border: "none", width: "32px", height: "32px",
  borderRadius: "50%", fontSize: "16px", cursor: "pointer", color: "#475569"
};
const contentStyle = {
  overflowY: "auto", padding: "20px 24px",
  flex: 1, fontSize: "13.5px", color: "#444", lineHeight: "1.7"
};
const paraStyle = { marginBottom: "8px" };
const listStyle = { paddingLeft: "20px", marginBottom: "8px", display: "flex", flexDirection: "column", gap: "4px" };
const checkboxRowStyle = {
  display: "flex", alignItems: "center", gap: "10px",
  padding: "14px 24px", borderTop: "1px solid #eee", background: "#fafffe", flexShrink: 0
};
const actionsStyle = {
  display: "flex", gap: "10px", justifyContent: "flex-end",
  padding: "14px 24px", borderTop: "1px solid #eee", flexShrink: 0
};
const acceptBtnStyle = {
  background: "#24aeb1", color: "#fff", border: "none",
  padding: "10px 24px", borderRadius: "8px", fontWeight: "600", fontSize: "14px", cursor: "pointer"
};
const cancelBtnStyle = {
  background: "#f1f5f9", color: "#333", border: "none",
  padding: "10px 20px", borderRadius: "8px", fontWeight: "500", fontSize: "14px", cursor: "pointer"
};

export default PrivacyPolicy;